import { createI18n } from 'vue-i18n'
import ar from './locales/ar'
import en from './locales/en'
import {
  DEFAULT_LOCALE,
  LOCALE_STORAGE_KEY,
  SUPPORTED_LOCALES,
  type Locale,
  type MessageSchema,
} from './types'

function readStoredLocale(): Locale {
  try {
    const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
    if (stored && SUPPORTED_LOCALES.includes(stored as Locale)) {
      return stored as Locale
    }
  } catch {
    /* ignore */
  }
  return DEFAULT_LOCALE
}

const numberFormats = {
  ar: {
    currency: { style: 'currency', currency: 'SAR', currencyDisplay: 'symbol' },
    decimal: { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 },
    percent: { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 1 },
  },
  en: {
    currency: { style: 'currency', currency: 'SAR', currencyDisplay: 'symbol' },
    decimal: { style: 'decimal', minimumFractionDigits: 0, maximumFractionDigits: 2 },
    percent: { style: 'percent', minimumFractionDigits: 0, maximumFractionDigits: 1 },
  },
} as const

const datetimeFormats = {
  ar: {
    short: { year: 'numeric', month: 'short', day: 'numeric' },
    long: { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' },
    time: { hour: '2-digit', minute: '2-digit' },
  },
  en: {
    short: { year: 'numeric', month: 'short', day: 'numeric' },
    long: { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' },
    time: { hour: '2-digit', minute: '2-digit' },
  },
} as const

const i18n = createI18n<[MessageSchema], Locale>({
  legacy: false,
  globalInjection: true,
  locale: readStoredLocale(),
  fallbackLocale: 'en',
  messages: { ar, en },
  numberFormats,
  datetimeFormats,
})

export default i18n
export { ar, en }
export * from './types'

